import { useDispatch, useSelector } from 'react-redux';

// selectors
import * as tradeInsSelectors from '@makemydeal/dr-dash-store/selectors/tradeIns';
import * as tradeInsActionCreators from '@makemydeal/dr-dash-store/actions/tradeInsActionCreators';
import { useSingleTradeInFormProvider } from '../MultiTradeIn/TradeInFormProvider';

// libraries
import { kebabCase } from '@makemydeal/dr-common-utils';

// constants
import { BODY_STYLE, ZERO_WIDTH_SPACE } from '../../../constants';

// components
import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// styling
import { DetailContainer } from '../trade.style';

interface BodyStyleFieldProps {
    hasTradeIn: boolean;
    isManualFormOpen: boolean;
    disabled?: boolean;
}

export const BodyStyleField: React.FC<BodyStyleFieldProps> = ({ hasTradeIn, isManualFormOpen, disabled }) => {
    const dispatch = useDispatch();
    const { tradeInIndex } = useSingleTradeInFormProvider();
    const bodyStyle = useSelector(tradeInsSelectors.getBodyStyle(tradeInIndex));

    const onChange = (event: any) => {
        dispatch(tradeInsActionCreators.updateTradeInBodyStyle(event.target.value, tradeInIndex));
    };

    return (
        <>
            {isManualFormOpen ? (
                <TextInput
                    label={BODY_STYLE}
                    data-testid={kebabCase(BODY_STYLE)}
                    name={kebabCase(BODY_STYLE)}
                    onChange={onChange}
                    value={bodyStyle}
                    disabled={disabled}
                    size="sm"
                    selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                />
            ) : (
                <>
                    {hasTradeIn && (
                        <DetailContainer>
                            <Typography variant="label-md" color="sem.color.on-surface.muted" sx={{ marginBottom: '8px' }}>
                                {BODY_STYLE}
                            </Typography>
                            <Typography variant="body-md" tag="span" data-testid="trade-body-style-value-label">
                                {bodyStyle || ZERO_WIDTH_SPACE}
                            </Typography>
                        </DetailContainer>
                    )}
                </>
            )}
        </>
    );
};
